export const targetGroupsBySNConstants = {
  TARGET_GROUPS_BY_SN_LOADING: "TARGET_GROUPS_BY_SN_LOADING",
  TARGET_GROUPS_BY_SN_SUCCESS: "TARGET_GROUPS_BY_SN_SUCCESS",
  TARGET_GROUPS_BY_SN_FAILURE: "TARGET_GROUPS_BY_SN_FAILURE",
};

export const createTargetGroupsBySNConstants = {
  CREATE_TARGET_GROUPS_BY_SN_LOADING: "CREATE_TARGET_GROUPS_BY_SN_LOADING",
  CREATE_TARGET_GROUPS_BY_SN_SUCCESS: "CREATE_TARGET_GROUPS_BY_SN_SUCCESS",
  CREATE_TARGET_GROUPS_BY_SN_FAILURE: "CREATE_TARGET_GROUPS_BY_SN_FAILURE",
};

export const editTargetGroupsBySNConstants = {
  EDIT_TARGET_GROUPS_BY_SN_LOADING: "EDIT_TARGET_GROUPS_BY_SN_LOADING",
  EDIT_TARGET_GROUPS_BY_SN_SUCCESS: "EDIT_TARGET_GROUPS_BY_SN_SUCCESS",
  EDIT_TARGET_GROUPS_BY_SN_FAILURE: "EDIT_TARGET_GROUPS_BY_SN_FAILURE",
};

export const deleteTargetGroupsBySNConstants = {
  DELETE_TARGET_GROUPS_BY_SN_LOADING: "DELETE_TARGET_GROUPS_BY_SN_LOADING",
  DELETE_TARGET_GROUPS_BY_SN_SUCCESS: "DELETE_TARGET_GROUPS_BY_SN_SUCCESS",
  DELETE_TARGET_GROUPS_BY_SN_FAILURE: "DELETE_TARGET_GROUPS_BY_SN_FAILURE",
};

export const addTargetGroupsBySNConstants = {
  ADD_TARGET_GROUPS_BY_SN_LOADING: "ADD_TARGET_GROUPS_BY_SN_LOADING",
  ADD_TARGET_GROUPS_BY_SN_SUCCESS: "ADD_TARGET_GROUPS_BY_SN_SUCCESS",
  ADD_TARGET_GROUPS_BY_SN_FAILURE: "ADD_TARGET_GROUPS_BY_SN_FAILURE",
};

export const removeTargetGroupsBySNConstants = {
  REMOVE_TARGET_GROUPS_BY_SN_LOADING: "REMOVE_TARGET_GROUPS_BY_SN_LOADING",
  REMOVE_TARGET_GROUPS_BY_SN_SUCCESS: "REMOVE_TARGET_GROUPS_BY_SN_SUCCESS",
  REMOVE_TARGET_GROUPS_BY_SN_FAILURE: "REMOVE_TARGET_GROUPS_BY_SN_FAILURE",
};

export const deleteTargetGroupsConstants = {
  DELETE_TARGET_GROUPS_LOADING: "DELETE_TARGET_GROUPS_BY_SN_LOADING",
  DELETE_TARGET_GROUPS_SUCCESS: "DELETE_TARGET_GROUPS_BY_SN_SUCCESS",
  DELETE_TARGET_GROUPS_FAILURE: "DELETE_TARGET_GROUPS_BY_SN_FAILURE",
};
